/* eslint-disable react-hooks/exhaustive-deps */
import ArrowBack from '@mui/icons-material/ArrowBackIos';
import Switch from '@mui/material/Switch';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import placeholder from '../../../../assets/img/skills-outline.svg';
import Thumbnail from '../../../components/ThumbnailComponent';
import TextInput from '../../../components/UI/TextInput';
import TextareaInput from '../../../components/UI/TextareaInput';
import PageLoader from '../../../components/loaders/PageLoader';
import { convertJsonToFormData } from '../../../helpers/helper';
import { GET, PUT } from '../../../services/rest.service';

const SkillUpdate = () => {
  const [skill, setSkill] = useState({});
  const [icon, setIcon] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [showOnHomePage, setShowOnHomePage] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      skill_id: skill._id,
      title: skill.title,
      status: skill.status,
      description: skill.description,
      showOnHomePage: showOnHomePage ? 'true' : 'false',
    };
    if (icon) payload.icon = icon;
    const formData = convertJsonToFormData(payload);
    try {
      await PUT(`/admin/skill/${skill._id}/edit`, formData);
      navigate(-1);
      toast.success('Skill Updated!');
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleFileChange = (e) => {
    setIcon(e.target.files[0]);
  };

  const handleTitleChange = (e) => {
    setSkill({ ...skill, title: e.target.value });
  };

  const handleDescriptionChange = (e) => {
    setSkill({ ...skill, description: e.target.value });
  };

  const getSkill = async () => {
    try {
      const res = await GET(`/admin/skill/get/${id}`);
      setSkill(res.data);
      setShowOnHomePage(res.data.showOnHomePage);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    getSkill();
  }, []);

  const toggleSwitch = (data) => {
    setShowOnHomePage(data);
  };

  if (isEmpty(skill)) {
    return <PageLoader />;
  }

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-lg-8 mb-5">
            <div className="card">
              <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">
                  <a href="#!" onClick={() => navigate(-1)}>
                    <ArrowBack />
                  </a>
                  Update Skill Details
                </h3>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-3">
                      <div className="user-avatar">
                        <label htmlFor="skill">
                          <Thumbnail
                            file={icon}
                            source={skill.icon.url}
                            style={{ width: '150px', height: '150px' }}
                            placeHolderImage={placeholder}
                            className="rounded-circle mx-3 my-2 my-lg-0 img-fluid c-pointer"
                          />
                        </label>
                        <input id={'skill'} type="file" className="d-none" onChange={handleFileChange} />
                      </div>
                    </div>
                    <div className="col-lg-9">
                      <div className="row">
                        <TextInput
                          value={skill.title}
                          label={'Title'}
                          labelClasses={'text-uppercase'}
                          placeholder={'Please enter a skill name'}
                          size={'col col-lg-6'}
                          error={''}
                          name={'title'}
                          id={'title'}
                          onChange={handleTitleChange}
                        />
                        <div className="form-group ">
                          <label>Show on HomePage:</label>
                          <Switch onClick={() => toggleSwitch(!showOnHomePage)} checked={showOnHomePage ? true : false} />
                        </div>

                        <TextareaInput
                          label={'Description'}
                          labelClasses={'text-uppercase'}
                          placeholder={'Short description'}
                          size={'col-12'}
                          value={skill.description}
                          error={''}
                          onChange={handleDescriptionChange}
                          name={'description'}
                          id={'description'}
                        />

                        {/* <div className="form-group col-12">
                          <label className="form-label text-uppercase">HTML Content</label>
                          <CKEditor
                            className="texteditor"
                            editor={ClassicEditor}
                            data={content}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setContent(data);
                            }}
                          />
                        </div> */}

                        <div className="form-group col-12">
                          <button type="button" className="btn btn-danger btn-lg" onClick={() => navigate(-1)}>
                            Discard Changes
                          </button>
                          &nbsp;&nbsp;&nbsp;
                          <button type="submit" className="btn btn-primary btn-lg">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SkillUpdate;
